/**
 * Enforce minimum order quantity on the Stoles designer product page.
 * Do not observe the whole product tree — FPD mutates the DOM constantly
 * and an attributes MutationObserver will freeze the page in an endless load.
 */
(function () {
  const MIN_QTY = window.gradStolesProductConfig?.minQty ?? 6;
  const PRODUCT_HANDLES = window.gradStolesProductConfig?.productHandles ?? ['stoles'];
  let applying = false;

  function isStolesProductPage() {
    const handle = window.gradStolesProductConfig?.productHandle;
    if (handle && PRODUCT_HANDLES.includes(handle)) return true;
    return PRODUCT_HANDLES.some((h) => window.location.pathname.includes(`/products/${h}`));
  }

  function getQuantityInputs() {
    return document.querySelectorAll(
      '.product-form__quantity .quantity__input[name="quantity"], .price-per-item__container .quantity__input[name="quantity"]'
    );
  }

  function enforceQuantityInput(input) {
    if (!input || applying) return;

    const minStr = String(MIN_QTY);
    if (input.min !== minStr) input.min = minStr;
    if (input.getAttribute('data-min') !== minStr) input.setAttribute('data-min', minStr);

    const current = parseInt(input.value, 10);
    if (Number.isNaN(current) || current < MIN_QTY) {
      applying = true;
      input.value = minStr;
      applying = false;
    }
  }

  function enforceAllQuantityInputs() {
    if (applying) return;
    getQuantityInputs().forEach(enforceQuantityInput);
  }

  function onQuantityChange(event) {
    if (applying) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.matches('.product-form__quantity .quantity__input, .price-per-item__container .quantity__input')) {
      return;
    }

    const value = parseInt(input.value, 10);
    if (Number.isNaN(value) || value < MIN_QTY) {
      applying = true;
      input.value = String(MIN_QTY);
      applying = false;
    }
  }

  function init() {
    if (!isStolesProductPage()) return;

    enforceAllQuantityInputs();
    document.addEventListener('change', onQuantityChange, true);

    document.querySelectorAll('input[name="Style"], input[name="Size"]').forEach((el) => {
      el.addEventListener('change', () => {
        window.setTimeout(enforceAllQuantityInputs, 0);
        window.setTimeout(enforceAllQuantityInputs, 400);
      });
    });

    let ticks = 0;
    const intervalId = window.setInterval(() => {
      enforceAllQuantityInputs();
      ticks += 1;
      if (ticks >= 8) window.clearInterval(intervalId);
    }, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
